var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.667,
    height: 1.333,
    rx: 0.667,
    transform: "rotate(45 -2.186 7.552)",
    fill: "#4F4F4F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.667,
    height: 1.333,
    rx: 0.667,
    transform: "rotate(135 5.148 4.886)",
    fill: "#4F4F4F"
  })));
}

export default SvgRemove;